<template>
    <div class="d-flex align-center">
        <v-autocomplete
            ref="input"
            v-model="location"
            :items="items"
            :placeholder="$t('search_on_map')"
            bg-color="white"
            density="compact"
            hide-no-data
            hide-selected
            hide-details
            no-filter
            clearable
            return-object
            single-line
            variant="outlined"
            class="me-3 location"
            menu-icon="mdi-magnify"
            @update:model-value="change"
            @click:clear="clear"
            @update:search="onSearch"
        >
            <template v-slot:append-inner>
                <v-progress-circular v-if="loading" indeterminate size="24" color="grey" />
            </template>
            <template v-slot:item="{item, props}">
                <v-list-item v-bind="props">
                    <template v-slot:title>
                        <span v-text="item.raw.formatted_address" />
                    </template>
                </v-list-item>
            </template>
            <template v-slot:selection="{item}">
                {{ item.raw.formatted_address }}
            </template>
        </v-autocomplete>
    </div>
</template>

<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator'
    import {HotelMapLocationFilter} from '@/components/hotels/snippets/HotelMapLocationFilter.vue'
    import HotelDirectionMapInfoWindow from '@/components/hotels/HotelDirectionMapInfoWindow.vue'
    import {h, render} from 'vue'

    // TODO [P1] Need check
    @Component
    export class HotelMapDirectionFilter extends HotelMapLocationFilter {
        @Prop() markers
        polyline = null
        drivingDirectionData = null
        walkingDirectionData = null

        async makeDirection(point) {
            if (!point) {
                if (this.marker) toRaw(this.marker).setMap(null)
                toRaw(this.polyline).setMap(null)
                this.drivingDirectionData = null
                this.walkingDirectionData = null
                return
            }

            const request = {
                origin: this.markers[0].position.toJSON(),
                destination: point,
                travelMode: this.google.maps.DirectionsTravelMode.DRIVING,
                drivingOptions: {departureTime: new Date()},
            }
            const directionsService = new this.google.maps.DirectionsService()

            await directionsService.route(request, (response, status) => {
                if (status === this.google.maps.DirectionsStatus.OK) {
                    this.drivingDirectionData = response.routes[0]
                    this.polyline = new this.google.maps.Polyline({
                        path: response.routes[0].overview_path,
                        geodesic: true,
                        strokeColor: this.$vuetify.theme.themes.light.colors.primary,
                        strokeOpacity: 0.8,
                        strokeWeight: 3,
                    })

                    toRaw(this.polyline).setMap(toRaw(this.map))
                }
            })

            await directionsService.route(
                {...request, travelMode: this.google.maps.DirectionsTravelMode.WALKING},
                (response, status) => {
                    if (status === this.google.maps.DirectionsStatus.OK) {
                        this.walkingDirectionData = response.routes[0]
                    }
                }
            )

            this.marker = new this.google.maps.Marker({
                position: point,
                icon: this.createMarkerIcon(),
                map: this.map,
            })

            this.marker.addListener('click', () => {
                if (!this.marker.infoWindow) {
                    this.isMapPositionSets = true
                    this.showDirectionWindow(this.marker)
                }
            })

            this.showDirectionWindow(this.marker)
        }

        showDirectionWindow(marker) {
            const markerWithInfoWindow = this.markers.find(marker => marker.infoWindow)
            if (markerWithInfoWindow) {
                markerWithInfoWindow.infoWindow.close()
                markerWithInfoWindow.infoWindow = null
            }

            const InfoWindowComponent = h(HotelDirectionMapInfoWindow, {
                drivingDirectionData: this.drivingDirectionData,
                walkingDirectionData: this.walkingDirectionData,
                location: this.location,
            })
            InfoWindowComponent.appContext = useNuxtApp().vueApp._context
            const content = document.createElement('div')
            render(InfoWindowComponent, content)

            marker.infoWindow = new this.google.maps.InfoWindow({content})
            this.google.maps.event.addListener(marker.infoWindow, 'closeclick', () => {
                marker.infoWindow.close()
                marker.infoWindow = null
            })
            marker.infoWindow.open(this.map, marker)
        }

        change() {
            if (this.location) {
                const center = this.location.geometry.location.toJSON()

                this.makeDirection(center)
            }
            this.$refs.input.blur()
        }

        clear() {
            if (this.marker) toRaw(this.marker).setMap(null)
            this.marker = null
            if (this.polyline) toRaw(this.polyline).setMap(null)
            this.polyline = null
        }
    }

    export default HotelMapDirectionFilter
</script>
